<template>
  <div class="inner">
    <!--君临天下礼包-->
    <div class="e4table1"><span class="sping">商品<img
          class="bax"
          src="../../assets/img/bax.png"
          alt=""
        ><b class="bb">01</b></span></div>
    <div class="e4table2">
      <div class="conmmp">
        <p class="tit1">君临天下大礼包<span class="tit2">限时销售</span></p>
        <p>活动时间：<span class="tit2 text2">{{saleTime}}</span></p>
        <p>活动期间玩家可以在游戏内商城内购买:<span class="tit2">君临天下大礼包</span>打开即可获得：<span class="tit2">暴君-稳定芯片，暴君武器幸运包（7天）</span></p>
      </div>
      <div style="clear:both"></div>
      <div class="e1_left">
        <div class="e1_image">
          <img src="../../assets/img/tip2.png">
        </div>
        <div class="qqpng"><img src="../../assets/img/qq.png"></div>
        <div class="e1_text">
          <span class="e1_name">暴君-稳定芯片</span>
          <span class="e1_jies">结合史前神秘云石制作的暴君武器专用挂件，可提高瞄准状态下的射击稳定。</span>
        </div>
      </div>
      <div class="e1_right">
        <div class="e1_image">
          <img src="../../assets/img/tip3.png">
        </div>
        <div class="qqpng"><img src="../../assets/img/qq.png"></div>
        <div class="e1_text">
          <span class="e1_name">“暴君武器专用”</span>
          <span class="e1_jies">加装芯片后将自动与武器绑定，当武器到期后将自动卸载</span>
        </div>
      </div>
    </div>
    <div class="e4table3"></div>

    <!--辉煌暴君大礼包-->
    <div class="e4table1"><span class="sping">商品<img
          class="bax"
          src="../../assets/img/bax.png"
          alt=""
        ><b class="bb">02</b></span></div>
    <div class="e4table2">
      <div class="conmmp">
        <p class="tit1">辉煌暴君大礼包<span class="tit2">限时销售</span></p>
        <p>活动时间：<span class="tit2 text2">{{saleTime}}</span></p>
        <p>活动期间玩家可以在游戏内商城内购买:<span class="tit2">辉煌暴君大礼包</span>打开即可获得：<span class="tit2">暴君-精准芯片，暴君武器幸运包（7天）</span></p>
      </div>
      <div style="clear:both"></div>
      <div class="e1_left">
        <div class="e1_image">
          <img src="../../assets/img/tip2.png">
        </div>
        <div class="qqpng"><img src="../../assets/img/qq.png"></div>
        <div class="e1_text">
          <span class="e1_name">暴君-精准芯片</span>
          <span class="e1_jies">结合史前神秘云石制作的暴君武器专用挂件，能够增加瞄准射击精度。</span>
        </div>
      </div>
      <div class="e1_right">
        <div class="e1_image">
          <img src="../../assets/img/tip3.png">
        </div>
        <div class="qqpng"><img src="../../assets/img/qq.png"></div>
        <div class="e1_text">
          <span class="e1_name">“暴君武器专用”</span>
          <span class="e1_jies">加装芯片后将自动与武器绑定，当武器到期后将自动卸载</span>
        </div>
      </div>
    </div>
    <div class="e4table3"></div>
  </div>
</template>
<script>
export default {
  name: "Bigpackge",
  data() {
    return {
      saleTime: "3月26日——4月8日"
    };
  }
};
</script>

<style lang="scss" scoped>
.e4table1 {
  width: 100%;
  height: 140px;
  background: url("../../assets/img/table1.png") no-repeat center top;
  font-size: 34px;
  color: #2d2a2a;
  font-weight: bold;
  text-align: center;
  line-height: 62px;
  position: relative;
  span {
    display: block;
    padding-top: 30px;
    height: 62px;
  }
  span.sping {
    margin-left: -83px;
    .bax {
      position: absolute;
      top: 15px;
      margin-left: 5px;
    }
    .bb {
      position: absolute;
      top: 33px;
      left: 633px;
      font-size: 30px;
    }
  }
}
.e4table2 {
  width: 100%;
  background: url("../../assets/img/table2.png") repeat-y center;
  font-size: 16px;
  position: relative;
  overflow: hidden;
  .conmmp {
    text-align: center;
    p.tit1 {
      font-size: 32px;
      font-weight: 700;
      
    }
    p {
      margin-bottom: 8px;
      .tit2 {
        color: #ec1111;
      }
    }
  }
  .e1_left {
    width: 456px;
    height: 250px;
    margin-left: 118px;
    float: left;
    overflow: hidden;
    position: relative;
    .e1_image {
      height: 170px;
      width: 120px;
      float: left;
      img {
        padding: 80px 0px 0px 20px;
      }
    }
    .qqpng {
      position: absolute;
      top: 105px;
      left: 104px;
    }
    .e1_text {
      height: 380px;
      overflow: hidden;
      .e1_name {
        display: block;
        font-size: 22px;
        color: #ec1111;
        margin: 64px 0px 30px 49px;
      }
      .e1_jies {
        display: block;
        margin: 0px 0px 10px 50px;
      }
    }
  }
  .e1_right {
    width: 471px;
    height: 250px;
    margin-left: 30px;
    float: left;
    overflow: hidden;
    zoom: 1;
    position: relative;
    .e1_image {
      height: 170px;
      width: 120px;
      float: left;
      img {
        padding: 80px 0px 0px 10px;
      }
    }
    .qqpng {
      position: absolute;
      top: 105px;
      left: 104px;
    }
    .e1_text {
      height: 380px;
      overflow: hidden;
      .e1_name {
        display: block;
        font-size: 22px;
        color: #ec1111;
        margin: 64px 0px 30px 49px;
      }
      .e1_jies {
        display: block;
        margin: 0px 0px 10px 50px;
      }
    }
  }
}
.e4table3 {
  width: 100%;
  height: 22px;
  background: url("../../assets/img/table3.png") no-repeat center bottom;
}
</style>











// WEBPACK FOOTER //
// src/components/e1_module/BigPackge.vue